import styled from 'styled-components';
import ImageUploader from '../../components/ImageUploader/ImageUploader';
import { StyledImageHolder } from '../../components/ImageUploader/ImageUploader.styles';

export const StyledIconUploader = styled(ImageUploader)`
  width: 100px;

  ${StyledImageHolder} {
    height: 100px;
    width: 100px;
    margin: 0 auto;
    margin-top: 10px;
  }
`

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
